
const customTheme = {
    // -- SPACING
    spacing: {
        gap: "8px",
        smallest: "16px",
        small: "24px",
        medium: "32px",
        large: "40px",
        largest: "48px",
    },
    sizes: {
        iconButtonSize: "32px",
        sideMenu: "256px",
        sideBar: {
            default: "400px",
            MD: "360px",
            SM: "300px",
            XS: "100%",
        },
        mainContent: {
            default: "720px",
            SM: "350px",
            XS: "100%",
        },
        welcomeImageHeight: "384px",
        welcomeImageHeightMobile: "192px",
        knowledgeBaseCoverImageHeightMobile: "133px",
        tabBarHeight: "48px",
        appBarHeight: "56px",
        bottomControlsHeight: "42px",
        userProfileImageSize: 128,
        pagesTopPadding: "40px",
        pagesVideoHeight: "405px",
        moreInfoWidth: "360px",
        storyCardWidth: "344px",
        storyImageHeight: "230px",
        chapterImageHeight: "172px",
        chapterCardWidth: "256px",
        pagesMaxWidth: "1024px",
    },

    // -- BASIC
    primary: "rgba(64, 74, 88, 1)",
    contrast: "rgba(255, 108, 92, 1)",
    contrastOnWhite: null,

    // -- ADVANCED
    primaryDark: null,
    primaryLight: null,
    primaryText: null,

    contrastDark: null,
    contrastLight: null,
    contrastText: null,

    mainBg: null,

    success: "rgba(156, 206, 124, 1)",
    successText: null,
    successDark: null,
    error: "rgba(253, 112, 96, 1)",
    errorText: null,
    score: "rgba(245, 166, 35, 1)",
    scoreText: null,

    checkmark: "rgba(156, 206, 124, 1)",
    white: "rgba(255, 255, 255, 1)",
    black: "rgba(0, 0, 0, 1)",
    black10: "rgba(0, 0, 0, 0.1)",
    black20: "rgba(0, 0, 0, 0.2)",
    black35: "rgba(0, 0, 0, 0.35)",
    black70: "rgba(0, 0, 0, 0.7)",

    // SOCIAL
    facebookColor: "#3B5998",
    instagramColor: "#833AB4",
    linkedInColor: "#0077B5",
    twitterColor: "#1DA1F2",
    skypeColor: "#00AFF0",
}

export default customTheme



// WEBPACK FOOTER //
// ./src/ThemeProvider/theme.js